var tzlookup = require("tz-lookup");

export const dateService = {
		formatDateBlank,
		formatDateTimeTracks,
		formatDateTime,
    formatDate,
    unformatDate,
    formatTime,
    formatDuration,
    getCurrentDate,
    getDate,
    getOnlyDate,
    getDateTime,
    getNextDate,
    getPreviousDate,
    getYesterday,
		formatDurationMilliToHourSec,
		formatDateTimeLocal: (date, pointObj) => __formatDateTimeLocal(date, pointObj),
		formatDateTimeLocalShort: (date, pointObj) => __formatDateTimeLocalShort(date, pointObj),
		formatDateTimeBottomTable,
	getTomorrow,
	getStartOfDay,
	getPreviousDay,
	getTomorrowEx,
	findDateInSummaries: (date, ranges) => _findDateInSummaries(date, ranges),
	getFormattedStartEndDatesPair: (dateStart, daysApart) => __getFormattedStartEndDatePair(dateStart, daysApart),
	getISOUTCFormat: (input) => _getISOUTCFormat(input)
};
var jstz = require('jstz');
const moment = require('moment-timezone'); //moment-timezone
var tz = jstz.determine();
var timeZone = moment.tz([2012, 0], tz.name()).format('z');
// #region date
/**
 * @name formatDateBlank
 * @desc get formatted date 2022-07021T15:56:29-04:00
 * @param dateTime
 */
 function formatDateBlank (dateTime) {
	if (dateTime === undefined || dateTime === null) { return 'No Data'; }
	var formattedDate = moment(dateTime).format();
	return formattedDate;
}

/**
 * @name formatDateTimeTracks
 * @desc get formatted date 'MM-DD-YYYY hh:mm A tz'
 * @param dateTime
 */
function formatDateTimeTracks (dateTime) {
	const isoDate = new Date(dateTime).toISOString();
	let datePart = isoDate.substring(0, 10);
	let simple = isoDate.substring(0, isoDate.length - 7);
	let zonePart = isoDate.substring(isoDate.length - 3);
	let timePart = moment(new Date(simple)).format('h:mm A');
	let fullDate = datePart + ' ' + timePart + ' ' + zonePart;
	return datePart;
}
// function formatDateTimeTracks (dateTime) {
// 	var datePart = dateTime.substring(0, 10)
// 						var simple = dateTime.substring(0, dateTime.length - 7)
// 						var timePart = moment(new Date(simple)).format('h:mm A')
// 						var zonePart = dateTime.substring(dateTime.length - 3)
// 						var fullDate = datePart + ' ' + timePart + ' ' + zonePart
// 						return (
// 							fullDate
// 						)
// }

/**
 * @name formatDateTime
 * @desc get formatted date 'MM-DD-YYYY hh:mm A'
 * @param dateTime
 */
function formatDateTime (dateTime) {
	if (dateTime === undefined || dateTime === null) { return 'No Data'; }
	var formattedDate = moment(dateTime).format('MM-DD-YYYY hh:mm A');
	return formattedDate;
}
/**
 * @name formatDate
 * @desc get formatted date 'MM-DD-YYYY'
 * @param date
 */
function formatDate (date) {
	if (date === undefined || date === null) { return 'No Data'; }
	// Format date using moment.js and return formatted date to fnCallBack
	var formattedDate = moment(date).format('MM-DD-YYYY');
	return (formattedDate);
}
/**
 * @name unformatDate
 * @desc get formatted date 'MM-DD-YYYY'
 * @param date
 */
function unformatDate (date) {
	if (date === undefined || date === null) { return 'No Data'; }
	return moment(date).format('YYYY-MM-DD');
}
/**
 * @name formatTime
 * @desc get formatted time 'hh:mm a'
 * @param time
 */
function formatTime (time) {
	if (time === undefined || time === null) { return 'No Data'; }
	// Format date using moment.js and return formatted date to fnCallBack
	var formattedTime = moment(time).format('hh:mm a');
	return (formattedTime + " " + timeZone);
}
/**
 * @name formatDuration
 * @desc get formatted duration
 * @param time
 */
function formatDuration (time) {
	if (time === undefined || time === null) { return 'No Cluster'; }
	var result = time.substring(0, 5);
	var formattedDuration = result.replace(" ", "h ") + "m"; // Remove seconds and display hh:mm
	return (formattedDuration);
}
/**
 * @name getCurrentDate
 * @desc get current date 'MM-DD-YYYY'
 */
function getCurrentDate () {
	return moment().format('YYYY-MM-DD');
}

function getDate (date) {
	return date.substring(0, 10);
}

function getTime (date) {
	return date.getTime()
}

function getOnlyDate (date) {
	var onlyDate = date.substring(0, 10);
	return moment(onlyDate).format('YYYY-MM-DD');
}
/**
 * @name  getDateTime
 * @desc get formatted date 'MM-DD-YYYY hh:mm A'
 * @param date
 */
function getDateTime (date) {
	return moment(date).format('YYYY-MM-DD hh:mm A');
}
/**
 * @name  getNextDate
 * @desc get formatted next day date 'MM-DD-YYYY'
 * @param date
 */
function getNextDate (date) {
	var onlyDate = date.substring(0, 10);
	return moment(onlyDate).add(1, 'days').format('YYYY-MM-DD');
}
/**
 * @name  getPreviousDate
 * @desc get formatted previous day date 'MM-DD-YYYY'
 * @param date
 */
function getPreviousDate (date) {
	var onlyDate = date.substring(0, 10);
	return moment(onlyDate).add(-1, 'days').format('YYYY-MM-DD');
}
/**
 * @name  getYesterday
 * @desc get formatted Yesterday date 'MM-DD-YYYY'
 * @param date
 */
function getYesterday () {
	var prevDate = moment().format('YYYY-MM-DD');
	return moment(prevDate).add(-1, 'days').format('YYYY-MM-DD');
}

// #endregion date

function formatDurationMilliToHourSec (ms) {
  var duration = moment.duration(ms);
  if (duration.asHours() > 1) {
    return Math.floor(duration.asHours()) + "h" + moment.utc(duration.asMilliseconds()).format("mm") + "m";
  } else {
    return moment.utc(duration.asMilliseconds()).format("mm") + "m";
  }
}

// function __formatDateTimeLocal (date, pointObj) {
// 	var __localDateStringOptions = {
// 		year: 'numeric',
// 		month: '2-digit',
// 		day: '2-digit',
// 		timeZoneName: 'short',
// 		hour: '2-digit',
// 		minute: '2-digit',
// 		timeZone: tzlookup(pointObj.lat, pointObj.lon)
// 	};

// 	const d = new Date((date || '').replace('UTC', 'Z'));
// 	const formattedDate = d.toLocaleDateString([], __localDateStringOptions);

// 	// Get month as a two digit string
// 	let month = (d.getMonth() + 1).toString();
// 	if (month.length < 2) {
// 		month = '0' + month;
// 	}
// 	// Get day as two day string
// 	let day = d.getDate().toString();
// 	if (day.length < 2) {
// 		day = '0' + day;
// 	}

// 	let dateTime = d.getFullYear() + '-' + month + '-' + day;
// 	const time = formattedDate.split(',');
// 	if (time && time.length > 1) {
// 		dateTime += ' ' + time[1].trim();
// 	}

// 	// return convertTZ(dateTime, 'America/Los_Angeles')
// 	return dateTime;
// 	// return date
// }

function __formatDateTimeLocal (date, pointObj) {
	var jun = moment(date);
	jun.tz(tzlookup(pointObj.lat, pointObj.lon))    // 8am EDT
	var d = (moment(jun._d).format("MM-DD-YYYY HH:mm a")) + " " + tzlookup(pointObj.lat, pointObj.lon);
	return d
}
function __formatDateTimeLocalShort (date, pointObj) {
	let jun = moment(date);
	// DD - NOTE: Took out the call below to format based on the time zone, per Matthew this should be handled at the
	// API level and not in the UI
	// jun.tz(tzlookup(pointObj.lat, pointObj.lon))    // 8am EDT
	let d = (moment(jun._d).format("YYYY-MM-DD"));
	return d
}

function formatDateTimeBottomTable (dateTime, pointObj) {
	if (dateTime === undefined || dateTime === null) { return 'No Data'; }
	// var formattedDate = moment(dateTime).format('MM-DD-YYYY hh:mm A');
	var formattedDate = moment(dateTime).format('YYYY-MM-DD hh:mm A');
	var info = moment(dateTime).tz(tzlookup(pointObj.lat, pointObj.lon)).format('z');
	return formattedDate + ' ' + info;
}

function getTomorrow (srcDate) {
	return moment(srcDate).add(1, "days").format("YYYY-MM-DD");
}

function getTomorrowEx (srcDate) {
	const temp = moment(srcDate).format('YYYY-MM-DD');
	let newDate = moment(temp).add(1, 'days').format('YYYY-MM-DD');
	return newDate + "T00:00:00Z";
}

function getStartOfDay(dateStr) {
	let newDate = dateStr.substring(0, 10);
  	const finalDate = newDate + "T00:00:00Z";
  	console.log("getStartOfDay final date", finalDate);
	return finalDate;
}

/**
 * @name  getPreviousDay
 * @desc get formatted Yesterday date 'MM-DD-YYYY'
 * @param date
 */
function getPreviousDay (day) {
	var prevDate = moment(day).format('YYYY-MM-DD');
	return moment(prevDate).add(-1, 'days').format('YYYY-MM-DD');
}

/**
 * Iterates over a list of eagle day summary objects looking for the correct
 * entry based on the target date specified. The summary's start must be before
 * or equal to the target date AND the summary's end must be after or equal to
 * the target date
 * @param {*} date
 * @param {*} summaries - eagle day summaries
 * @returns
 */
function _findDateInSummaries(date, summaries) {
	// If we didn't get a date or summaries to search then just return null here
	if(!date || (!summaries || summaries.length === 0)) {
		return null;
	}

	// Get a moment instance of the date we'll be searching for
	const targetDate = moment(date),
		len = summaries.length;

	// Iterate over the summaries and check if our target date falls in
	// between the start and end of the day
	let summary = null;

	for(let idx = 0;idx<len;idx++) {
		const range = summaries[idx].properties,
			start = moment(range.DateStart),
			end = moment(range.DateEnd);

		// If the start date is the before or equal to the target date AND
		// if the end date is after or equal to the target date we've found our summary
		if(start.isSameOrBefore(targetDate) && end.isSameOrAfter(targetDate)) {
			summary = summaries[idx];
			break;
		}
	}

	// If we found a summary that meets the date criteria return it, otherwise
	// just return the last element in the array...
	return (!summary) ? summaries[summaries.length-1].properties : summary.properties;
}

/**
 * Returns a span of dates (start and end times) based on a start date. If expects the start date in 
 * format: 2023-09-24 12:00 AM and converts it to UTC format: 2023-09-24T00:00:00Z and calculates the
 * end date based on the value of daysApart. If daysApart is not provided it defaults to 1 day.
 * 
 * @param {*} dateStart start date
 * @param {*} daysApart span of days apart
 * @returns Map with keys of 'start' for start date and 'end' for end date
 */
function __getFormattedStartEndDatePair(dateStart, daysApart) {
	if(!dateStart) {
		return {"start": null, "end": null };
	}

	// Default to a span of 1 day if daysApart was not provided
	let span = 1;
	if(daysApart) {
		span = daysApart;
	}

	// Get the only the date portion of datetime
	let onlyDate = dateStart.substring(0, 10);
	// Get the end date based on the span
  	let date2 = moment(onlyDate).add(span, "days").format("YYYY-MM-DD");
	// Append 12 AM in UTC time format
	let startdate = onlyDate + "T00:00:00Z";
	let endDate = date2 + "T00:00:00Z";

	return {"start": startdate, "end": endDate };
}

/**
 * Format the given string to proper UTC ISO format
 * @param {*} input 
 * @returns formatted string
 */
function _getISOUTCFormat(input) {

	if(!input) {
		return input;
	}

	// Check if it is already ISO UTC
	// NOTE: Maybe move this into it's own function
	const isoUtcRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
  	if(isoUtcRegex.test(input) == true) {
		return input;
	}

	// Split on spaces
	let [datePart, timePart, period] = input.split(/[\s]+/); // ["2025-06-13", "03:00", "AM"]
	// Parse the time
	const timeParts = timePart.split(':');
  	let hours = parseInt(timeParts[0]);
  	let minutes = timeParts[1];

	// Adjust hour based on hour and period
  	if (period === "PM" && hours !== 12) hours += 12;
  	if (period === "AM" && hours === 12) hours = 0;

  	return `${datePart}T${hours.toString().padStart(2, '0')}:${minutes}:00Z`;
}
